import { enGB as dateFnsEnglish, it as dateFnsItalian } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';
import en from './en.json';
import it from './it.json';
// Namespace di proprietà di @repo/ui: i componenti condivisi leggono solo da
// qui, mai dal namespace `translation` delle app, così i testi viaggiano con
// il package e non dipendono dalle chiavi che ciascuna app sceglie.
export const UI_NAMESPACE = 'ui';
export const uiResources = { it, en };
export function registerUiTranslations(instance) {
    for (const [language, resources] of Object.entries(uiResources)) {
        instance.addResourceBundle(language, UI_NAMESPACE, resources, true, true);
    }
    return instance;
}
const ITALIAN_LOCALE = {
    language: 'it',
    tag: 'it-IT',
    dateFnsLocale: dateFnsItalian,
};
const ENGLISH_LOCALE = {
    language: 'en',
    tag: 'en-GB',
    dateFnsLocale: dateFnsEnglish,
};
// Un tag regionale (`en-US`, `it-CH`) conta per la sua lingua; una lingua che
// il prodotto non traduce ricade sull'italiano, la lingua di riferimento.
export function resolveUiLocale(language) {
    const [primary] = (language ?? '').toLowerCase().split(/[-_]/);
    return primary === 'en' ? ENGLISH_LOCALE : ITALIAN_LOCALE;
}
// Il locale di formattazione dei componenti condivisi segue la lingua attiva
// di i18next, così cambia insieme ai testi invece di leggere cookie o browser.
export function useUiLocale() {
    const { i18n } = useTranslation();
    return resolveUiLocale(i18n.language);
}
//# sourceMappingURL=index.js.map